{
  "actionbar.actions": "פעולות",
  "actionbar.actionsAvailable": "פעולות זמינות.",
  "actionbar.clearSelection": "נקה בחירה",
  "actionbar.selected": "{count, plural, =0 {לא בוצעה בחירה} one { # בחר} other {# נבחרו}}\",",
  "actionbar.selectedAll": "כל הפריטים שנבחרו",
  "button.pending": "ממתין ל",
  "calendar.invalidSelection": "נבחר {selectedCount, plural, one {תאריך} other {תאריכים}} אינו זמין.",
  "contextualhelp.help": "עזרה",
  "contextualhelp.info": "מידע",
  "datepicker.endTime": "שעת סיום",
  "datepicker.startTime": "שעת התחלה",
  "datepicker.time": "זמן",
  "dialog.alert": "התראה",
  "dialog.dismiss": "התעלם",
  "dropzone.replaceMessage": "שחרר את הקובץ להחלפה",
  "inlinealert.informative": "מידע",
  "inlinealert.negative": "שגיאה",
  "inlinealert.notice": "אזהרה",
  "inlinealert.positive": "הצלחה",
  "label.(optional)": "(אופציונלי)",
  "label.(required)": "(נדרש)",
  "menu.moreActions": "פעולות נוספות",
  "picker.placeholder": "בחר…",
  "slider.maximum": "מקסימום",
  "slider.minimum": "מינימום",
  "table.loading": "טוען...",
  "table.loadingMore": "טוען עוד...",
  "table.resizeColumn": "שנה את גודל העמודה",
  "table.sortAscending": "מיין בסדר עולה",
  "table.sortDescending": "מיין בסדר יורד",
  "tag.actions": "פעולות",
  "tag.hideButtonLabel": "הצג פחות",
  "tag.noTags": "ללא",
  "tag.showAllButtonLabel": "הצג הכל ({tagCount, number})",
  "breadcrumbs.more": "פריטים נוספים",
  "combobox.noResults": "אין תוצאות",
  "notificationbadge.indicatorOnly": "פעילות חדשה",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}